import React from 'react';
import ReactDOM from 'react-dom';
import request from 'superagent';
import Url from './Url';
import ErrorBoundary from '../ErrorBoundary';
import FileUploader from './FileUploader';

class FileUploaderWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            file: null,
            originalName: null,
            url: null,
            radio: null,
            message: null,
            error: null
        };
    }

    componentWillMount() {
        if (this.props.fileValue) {
            this.setState({ url: this.props.fileValue, message: "Your file is ready." });
        }
    }

    onChange(files) {
        if (files.length > 0) {
            this.setState({ loading: true, error: null, message: null, url: null, file: null, originalName: null }, () => {
                request.post(Url.prefixedUrl(`mandy.com/s3/process`)).send({
                    files: files,
                    type: typeof BlueCompass !== 'undefined' && BlueCompass.s3type ? BlueCompass.s3type : null,
                    converting: typeof BlueCompass !== 'undefined' && BlueCompass.s3converting ? BlueCompass.s3converting : null,
                    complete: typeof BlueCompass !== 'undefined' && BlueCompass.s3complete ? BlueCompass.s3complete : null,
                    loggedInUser: window.loggedInUser ? window.loggedInUser.uid : null
                })
                    .withCredentials()
                    .set('X-Requested-With', 'XMLHttpRequest')
                    .end((err, res) => {
                        if (err) {
                            this.onError('There has been an error uploading your file, please try again.');
                        }
                        if (res && res.status === 200 && res.body.success) {
                            if (res.body.file) { // complete
                                let radio = res.body.radio ? true : false;
                                
                                this.setState({ file: res.body.file, url: null, radio, loading: false, message: "Your file is ready." });
                            } else { // no complete
                                this.setState({ file: null, url: files[0].url, originalName: files[0].originalName, radio: null, loading: false, message: "Your file is ready." });
                            }

                            if (typeof window.afterUploadComplete === 'function') {
                                window.afterUploadComplete();
                            }
                        } else {
                            if (res && res.body && res.body.message) {
                                this.onError(res.body.message);
                            } else {
                                this.onError("Unexpected Error. Please try again.");
                            }
                        }
                    });
            });
        } else {
            this.setState({ url: null, file: null, radio: null, originalName: null });
        }
    }

    onError(error) {
        this.setState({ error, message: null, loading: false });
    }

    fileIcon() {
        switch (this.state.file.parenttype) {
            case 1:
                return <i className="fa fa-file-text-o"></i>;
            case 2:
                return <i className="fa fa-microphone"></i>;
            case 3:
                return <i className="fa fa-video-camera"></i>;
            default:
                return <i className="fa fa-file-text-o"></i>;
        }
    }

    inputName() {
        if (this.props.inputName) {
            return this.props.inputName;
        }
            
        return this.state.radio ? "file_uid" : "files[]";
    }

    fileInputForForms() {
        if (this.state.url) {
            return (
                <div>
                    <input id="FileUploaderFiles" name="FileUploaderFiles" type="hidden" value={this.state.url} />
                    <input id="FileUploaderFilesOriginalName" name="FileUploaderFilesOriginalName" type="hidden" value={this.state.originalName} />
                </div>
            );
        }
        if (this.state.file) {
            return (
                <div>
                    <input type="radio" name={this.inputName()} value={this.state.file.uid} id={`file-${this.state.file.uid}`} style={{ display: 'none' }} checked="checked"></input>
                    <label for={`file-${this.state.file.uid}`} style={{ display: 'block' }}>
                        <div className="media">
                            <span className="float-left d-none d-sm-block">
                                <div className="type-container">
                                    {this.fileIcon()}
                                </div>
                            </span>
                            <div className="media-body ml-3">
                                {this.state.file.txt}
                            </div>
                        </div>
                    </label>
                </div>
            );
        }
    }

    message() {
        if (this.state.loading) {
            return <p><i style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto' }} className="fa fa-circle-o-notch fa-spin fa-2x fa-fw"></i></p>;
        }
        return this.state.message ? <p>{this.state.message}</p> : null;
    }

    error() {
        return this.state.error ? <div className="form-control-feedback">{this.state.error}</div> : null;
    }

    render() {
        return (
            <div>
                {this.fileInputForForms()}
                <FileUploader accept={this.props.accept} buttonText={this.props.buttonText} tooltipText={this.props.tooltipText} onChange={(file) => this.onChange(file)} onError={(error) => this.onError(error)} singleFile={true} />
                {this.message()}
                {this.error()}
            </div>
        );
    }
}

FileUploaderWrapper.defaultProps = {
    inputName: null
}

let FileUploaderElements = document.getElementsByClassName('FileUploader');
if (FileUploaderElements.length > 0) {
    for (let key in FileUploaderElements) {
        if (FileUploaderElements.hasOwnProperty(key) && typeof FileUploaderElements[key].getAttribute === 'function') {
            if (typeof BlueCompass !== 'undefined' && BlueCompass) {
                let tooltipText = FileUploaderElements[key].getAttribute('data-tooltipText');
                let accept = FileUploaderElements[key].getAttribute('data-accept');
                let buttonText = FileUploaderElements[key].getAttribute('data-buttonText');
                let fileValue = FileUploaderElements[key].getAttribute('data-fileValue');
                let inputName = FileUploaderElements[key].getAttribute('data-inputName');

                ReactDOM.render(
                    <ErrorBoundary>
                        <FileUploaderWrapper
                            fileValue={fileValue}
                            accept={accept}
                            buttonText={buttonText}
                            tooltipText={tooltipText}
                            inputName={inputName}
                        />
                    </ErrorBoundary>, FileUploaderElements[key]);
            }
        }
    }
}